// extracted by mini-css-extract-plugin
export default {"companyContainer":"wK-z","companyImage":"xK-z","container":"yK-z","heading":"zK-z","darkText":"AK-z","smallHeading":"BK-z","darkBackground":"CK-z","whiteBackground":"DK-z"};